import { useNetworkStore } from '@/stores/use-network-store';
import { useSyncStore } from '@/stores/use-sync-store';

export function NetworkStatusBanner() {
  const isOnline = useNetworkStore((s) => s.isOnline);
  const isConnected = useNetworkStore((s) => s.isConnected);
  const syncStatus = useSyncStore((s) => s.syncStatus);
  const pendingCount = useSyncStore((s) => s.pendingCount);

  const isSyncing = syncStatus === 'pushing' || syncStatus === 'pulling';

  // Fully online and not syncing — hide banner
  if (isConnected && !isSyncing) return null;

  // Syncing in progress (push or pull)
  if (isSyncing) {
    return (
      <div className="shrink-0 flex items-center justify-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium">
        <svg className="h-4 w-4 animate-spin" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
          <path d="M12 2v4m0 12v4m-7.07-3.93l2.83-2.83m8.48-8.48l2.83-2.83M2 12h4m12 0h4m-3.93 7.07l-2.83-2.83M7.76 7.76L4.93 4.93" />
        </svg>
        {syncStatus === 'pushing'
          ? `Syncing ${pendingCount} pending transaction${pendingCount !== 1 ? 's' : ''}...`
          : 'Pulling updates from server...'}
      </div>
    );
  }

  // Offline
  return (
    <div className="shrink-0 flex items-center justify-center gap-2 px-4 py-2 bg-amber-600 text-white text-sm font-medium">
      <svg className="h-4 w-4" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
        <line x1="1" y1="1" x2="23" y2="23" />
        <path d="M16.72 11.06A10.94 10.94 0 0 1 19 12.55" />
        <path d="M5 12.55a10.94 10.94 0 0 1 5.17-2.39" />
        <path d="M10.71 5.05A16 16 0 0 1 22.56 9" />
        <path d="M1.42 9a15.91 15.91 0 0 1 4.7-2.88" />
        <path d="M8.53 16.11a6 6 0 0 1 6.95 0" />
        <line x1="12" y1="20" x2="12.01" y2="20" />
      </svg>
      {!isOnline
        ? "You're offline — bills will sync when connection restores"
        : 'Server unreachable — bills will be saved locally'}
      {pendingCount > 0 && (
        <span className="ml-1 px-1.5 py-0.5 rounded bg-white/20 text-xs">
          {pendingCount} pending
        </span>
      )}
    </div>
  );
}
